import { render } from "./MoveColisPage.vue?vue&type=template&id=3b588d43&ts=true"
import script from "./MoveColisPage.vue?vue&type=script&lang=ts"
export * from "./MoveColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__